'use client';

import { c as _c } from "react/compiler-runtime";
import { CookiesBanner } from '@/components/cookies-banner';
import { Toaster } from '@/components/ui/sonner';
import { ActiveLocationProvider } from '@/contexts/active-location-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { PosthogProvider } from './posthog-provider';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { FormDevtoolsPanel } from '@tanstack/react-form-devtools';
const queryClient = new QueryClient();
export function Providers(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CookiesBanner />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toaster icons={{
      success: <CircleCheckIcon className="size-4 text-green-500" />,
      info: <InfoIcon className="size-4 text-blue-500" />,
      warning: <TriangleAlertIcon className="size-4 text-yellow-500" />,
      error: <OctagonXIcon className="size-4 text-destructive" />,
      loading: <Loader2Icon className="size-4 animate-spin text-primary" />
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <PosthogProvider><QueryClientProvider client={queryClient}><ActiveLocationProvider>{children}{t1}{t2}</ActiveLocationProvider></QueryClientProvider></PosthogProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TanStackDevtools config={{
      position: "top-right"
    }} plugins={[{
      name: "Form",
      render: _temp
    }]} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp() {
  return <FormDevtoolsPanel />;
}